import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/about',
			name: 'about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/profile/about.vue')
		},
		{
			path: '/profile',
			name: 'profile',
			component: () => import('./views/profile/about.vue')  //公司简介
		},
		{
			path: '/culture',
			name: 'culture',
			component: () => import('./views/profile/culture.vue')  //公司文化
		},
		{
			path: '/news',
			name: 'news',
			component: () => import('./views/profile/news.vue')  //新闻中心
		},
		{
			path: '/news-details',
			name: 'news-details',
			component: () => import('./views/profile/news-details.vue')  //新闻中心-详情
		},
		{
			path: '/trends',
			name: 'trends',
			component: () => import('./views/profile/trends.vue') //党建动态
		},
		{
			path: '/trends-details',
			name: 'trends-details',
			component: () => import('./views/profile/trends-details.vue') //党建动态-详情
		},
        {
            path: '/product-category',
            name: 'product-category',
            component: () => import('./views/product/category.vue') //产品 首分类页面
        },
        {
            path: '/product-list',
            name: 'product-list',
            component: () => import('./views/product/list.vue') //产品 产品列表
        },
		{
			path: '/product-details',
			name: 'product-details',
			component: () => import('./views/product/list-details.vue') //产品 产品详情
		},
        {
            path: '/more',
            name: 'more',
            component: () => import('./views/product/more.vue') //产品 产品详情 更多
        },
		{
			path: '/solution',
			name: 'solution',
			component: () => import('./views/product/solution.vue') //产品 解决方案
		},
        {
            path: '/product-consult',
            name: 'product-consult',
            component: () => import('./views/product/consult.vue') //产品 在线咨询
        },
        {
            path: '/outlet',
            name: 'outlet',
            component: () => import('./views/marketingAndService/outlet.vue') //营销与服务 营销网络
        },
        {
            path: '/network',
            name: 'network',
            component: () => import('./views/marketingAndService/network.vue') //营销与服务 服务网点
        },
		{
			path: '/overseas-market',
			name: 'overseas-market',
			component: () => import('./views/marketingAndService/overseas-market.vue') //营销与服务 海外市场
		},
		{
			path: '/service',
			name: 'service',
			component: () => import('./views/marketingAndService/service.vue') //营销与服务 服务
		},
		{
			path: '/quality',
			name: 'quality',
			component: () => import('./views/marketingAndService/quality.vue') //营销与服务 质量
		},
		{
			path: '/development',
			name: 'development',
			component: () => import('./views/capacity/development.vue') //研发与制造 研发
		},
		{
			path: '/produce',
			name: 'produce',
			component: () => import('./views/capacity/produce.vue') //研发与制造 制造
		},
		{
			path: '/contact-us',
			name: 'contact-us',
			component: () => import('./views/contactUs/contact-us.vue') //联系我们
		},
		{
			path: '/join-us',
			name: 'join-us',
			component: () => import('./views/contactUs/join-us.vue') //招聘
		}

	],
    scrollBehavior(to, from,savedPosition) {
		return {
			x: 0,
			y: 0
		}
    }
})
